import React, { useEffect, useRef, useState } from "react";
import "./RevealFX.css"; // Make sure the CSS is linked

const RevealFX = ({ children, overlayColor = "#1e90ff" }) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing after reveal
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`reveal-container ${isVisible ? "visible" : ""}`}
    >
      <div className="reveal-content">{children}</div>
      <div
        className="reveal-overlay"
        style={{ backgroundColor: overlayColor }}
      ></div>
    </div>
  );
};

export default RevealFX;
